<template>
  <a-modal :title="title" v-model="modalOpened" :maskClosable="false" :destroyOnClose="true">
    <div class="w-full" ref="container">
      <div v-if="!currentFile" ref="dropZone"></div>
      <div v-if="currentFile" class="w-full flex flex-col items-center justify-center p-2">
        <svgicon :name="currentFileIcon" original width="120" height="120"></svgicon>
        <span class="mt-6 text-lg">{{ currentFile.name }}</span>
        <a-button @click="changeFile">Cambia file</a-button>
      </div>
      <div ref="statusBar"></div>
    </div>

    <a-form-item label="Tipo di documento" class="w-full mt-8">
      <a-select class="w-full" :value="selectedType" @change="updateSelection">
        <a-select-option v-for="(value, key) in options" :key="key" :value="key" :title="value">
          {{ value }}
        </a-select-option>
      </a-select>
    </a-form-item>

    <template slot="footer">
      <a-button key="back" @click="modalOpened = false">Chiudi</a-button>
      <a-button
        :disabled="!currentFile"
        key="submit"
        type="primary"
        :loading="uploading"
        @click="upload"
      >
        Aggiungi Allegato
      </a-button>
    </template>
  </a-modal>
</template>

<script>
import Vue from 'vue';
const Uppy = require('@uppy/core');
const DragDrop = require('@uppy/drag-drop');
const StatusBar = require('@uppy/status-bar');
const XHRUpload = require('@uppy/xhr-upload');

export default {
  name: 'FileUploader',

  data() {
    return {
      order_id: null,
      uploading: false,
      modalOpened: false,
      uppy: null,
      title: null,
      attachable_type: null,
      attachable_id: null,
      currentFile: null,
      currentFileIcon: null,
      selectedType: 'certificate',
      options: {
        // expertise: 'Perizia Liutaio',
        certificate: 'Certificato di valore'
      }
    };
  },

  watch: {
    modalOpened: function(val, old) {
      if (!val) this.close();

      if (!old && val) {
        Vue.nextTick(() => this.initUppy());
      }
    }
  },

  mounted() {},

  methods: {
    updateSelection(e) {
      // console.log('updateSelection', e);
      this.selectedType = e;
      // console.log(this.options[this.selectedType]);
    },

    initUppy() {
      this.uppy = new Uppy({
        debug: true,
        autoProceed: false,
        allowMultipleUploads: false,
        restrictions: {
          maxFileSize: 100000000,
          minFileSize: null,
          maxTotalFileSize: 100000000,
          maxNumberOfFiles: 1,
          minNumberOfFiles: 1,
          allowedFileTypes: ['image/*', '.pdf']
        }
      });

      this.uppy
        .use(DragDrop, {
          target: this.$refs.dropZone,
          locale: {
            strings: {
              dropHereOr: 'Trascina un file o %{browse}',
              browse: 'clicca qui per aggiungere un file'
            }
          }
        })
        .use(XHRUpload, {
          endpoint: '/api/attachments',
          formData: true,
          fieldName: 'attachment'
        })
        .use(StatusBar, {
          target: this.$refs.statusBar,
          hideUploadButton: true,
          hideAfterFinish: false
        })
        .on('upload-success', (file, response) => {
          console.log('upload success!', file, response);

          this.$notification.success({
            message: 'Allegato caricato con successo!',
            duration: 5
          });
          this.close();
        })
        .on('upload-error', (file, error, response) => {
          console.log('error with file:', file.id);
          console.log('error message:', error);
          console.log('error response:', response);

          if (response.status === 413) {
            // file is too large
            window.alert('Il file supera la dimensione massima');
          }
        });

      this.uppy.on('file-added', this.showFilePreview);
    },

    showFilePreview(file) {
      // hide dnd zone
      const dnd = this.$refs.container.querySelector('.uppy-DragDrop-container');
      dnd.style.display = 'none';

      this.currentFileIcon = this.deriveIconFromFile(file);
      this.currentFile = file;
    },

    deriveIconFromFile(file) {
      const iconsAvailable = ['bmp', 'doc', 'jpg', 'pdf', 'png', 'svg', 'zip'];

      if (!file.extension || !iconsAvailable.includes(file.extension)) {
        return 'unknown';
      }

      return file.extension;
    },

    changeFile() {
      this.uppy.reset();
      this.currentFileIcon = null;
      this.currentFile = null;

      // show dnd zone
      const dnd = this.$refs.container.querySelector('.uppy-DragDrop-container');
      dnd.style.display = 'block';
    },

    async upload() {
      this.uploading = true;

      this.uppy.setMeta({
        order_id: this.order_id,
        attachable_id: this.attachable_id,
        attachable_type: this.attachable_type,
        description: this.options[this.selectedType],
        title: this.options[this.selectedType],
        type: this.selectedType
      });

      await this.uppy.upload();
      this.uploading = false;
      this.$emit('upload-success');
    },

    open(order_id, attachable_type, attachable_id, title = 'Aggiungi allegato') {
      const validTypes = ['order_item', 'order', 'quotation'];
      if (validTypes.indexOf(attachable_type) === -1) {
        throw 'Invalid attachable_type, must be one of ' + validTypes.join(', ');
      }

      this.order_id = order_id;
      this.attachable_type = attachable_type;
      this.attachable_id = attachable_id;
      this.title = title;

      this.modalOpened = true;
    },

    close() {
      this.modalOpened = false;
      this.order_id = null;
      this.attachable_type = null;
      this.attachable_id = null;
      this.title = null;
      if (this.uppy) {
        this.uppy.close();
        this.uppy = null;
      }
      this.currentFile = null;
      this.currentFileIcon = null;
    }
  }
};
</script>

<style lang="css" scoped></style>
